import React, { useState, useEffect } from "react";
import {
  closeMobileOtpModal,
  tick,
  resetCountdown,
  openforgotPasswordModal,
  openPopup,
} from "../../features/slices/ModalSlice";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { updateSelectedItem } from "../../features/slices/CommonSlice";
import {
  getUserData,
  relogin,
  sendMobileOTP,
  sendRegisterPhoneOtp,
  validateMobileOTP,
  verifyRegisterPhoneOtp,
} from "../../features/slices/UserSlice";
import { selectRegistrationAuth } from "../../features/slices/AppConfigSlice";
import { formatRegisterPhone } from "../../utils/buildRegisterPayload";

export default function MobileOtpForm() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const user = useSelector((state) => state.user);
  const modal = useSelector((state) => state.modal);
  const common = useSelector((state) => state.common);
  const registrationAuth = useSelector(selectRegistrationAuth);

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [otpSentMessage, setOtpSentMessage] = useState(
    "A 6 digit One Time Password has been sent to +91 1234 5678 91"
  );
  const isMobileOtpPopupVisible = useSelector(
    (state) => state.modal.isMobileOtpModalVisible
  );
  const countdown = useSelector((state) => state.modal.countdown);
  useEffect(() => {
    let intervalId;
    if (isMobileOtpPopupVisible || common.selectedItem) {
      intervalId = setInterval(() => {
        if (countdown > 0) dispatch(tick());
        else clearInterval(intervalId);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [isMobileOtpPopupVisible, dispatch, countdown]);

  const handleChange = (element, index) => {
    const actualValue = element.value;
    const value = element.value.replace(/[^0-9]/g, "");
    otp[index] = value;
    setOtp([...otp]);
    if (!actualValue.length) {
      if (element.previousSibling) {
        element.previousSibling.focus();
      }
      return;
    }
    // Focus next input
    if (value.length && element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const resetOtpCountdown = () => {
    setOtp(new Array(4).fill(""));
    const fromForgotPassword =
      modal.isFromForgotPassword || common.isFromForgotPassword;
    const { countryCode, phone } = user.phoneDetails || {};

    if (fromForgotPassword) {
      dispatch(sendMobileOTP({ ...user.phoneDetails, flowSource: "forgot" }));
    } else {
      const fullPhone = formatRegisterPhone(countryCode, phone);
      dispatch(
        sendRegisterPhoneOtp({
          phone: fullPhone,
          action: "register",
            delivery_method:
              registrationAuth?.default_delivery_method || "sms",
        })
      );
    }
    dispatch(resetCountdown());
  };
  const validateOTP = () => {
    const fromForgotPassword =
      modal.isFromForgotPassword || common.isFromForgotPassword;
    const otpValue = otp.join("");

    if (otpValue.length !== 4) return;

    if (fromForgotPassword) {
      dispatch(
        validateMobileOTP({
          data: { otp: otpValue, action: "forgot-password" },
          fromForgotPassword: true,
        })
      );
      return;
    }

    const { countryCode, phone } = user.phoneDetails || {};
    const fullPhone = formatRegisterPhone(countryCode, phone);

    dispatch(
      verifyRegisterPhoneOtp({
        phone: fullPhone,
        otp: otpValue,
        action: "register",
      })
    );
  };

  const closeOTPScreen = () => {
    dispatch(updateSelectedItem(null));
  };

  // Handle actions after OTP is verified
  useEffect(() => {
    if (
      user.otpVerified &&
      (modal.isFromForgotPassword || common.isFromForgotPassword)
    ) {
      dispatch(relogin());
      if (!isMobile) {
        dispatch(closeMobileOtpModal());
        dispatch(openforgotPasswordModal());
      } else {
        dispatch(updateSelectedItem(null));
        dispatch(
          updateSelectedItem({
            name: "forgotPassword",
            fromForgotPassword: true,
          })
        );
      }
    } else if (user.otpVerified) {
      if (!isMobile) {
        dispatch(closeMobileOtpModal());
      } else {
        dispatch(updateSelectedItem(null));
      }

      dispatch(openPopup("mobile"));

      if (user.userLoggedIn) {
        dispatch(getUserData({ source: "otp_verified", showLoader: true }));
      }
    }
  }, [
    user.otpVerified,
    user.userLoggedIn,
    modal.isFromForgotPassword,
    common.isFromForgotPassword,
    dispatch,
    isMobile,
  ]);

  const styles = {
    backgroundColor: isMobile ? "#111111" : "none",
    height: isMobile ? "100vh" : "auto",
    paddingBottom: isMobile ? "100px" : "auto",
  };
  return (
    <div
      className={`${isMobile ? "form-mobile otp-form px-3 pt-3" : ""}`}
      style={styles}
    >
      {isMobile && (
        <p className="text-center" style={{ color: "#EFC04B" }}>
          Mobile Verification
        </p>
      )}
      <p className={`${isMobile ? "text-center" : ""} text--normal`}>
        Please enter the One Time Password to verify your account
      </p>
      {user.error && (
        <p
          className={`${isMobile ? "text-center" : ""} text--medium`}
          style={{ color: "rgb(255, 64, 64)" }}
        >
          Error: {user.error}
        </p>
      )}
      {user.otpMessage && (
        <p
          className={`${isMobile ? "text-center" : ""} text-muted text--medium`}
        >
          {user.otpMessage}
        </p>
      )}

      <div className="otp-inputs d-flex m-auto justify-content-center">
        {otp.map((data, index) => {
          return (
            <input
              className="otp-field m-2 text-center"
              type="text"
              name="otp"
              maxLength="1"
              pattern="[^0-9]*"
              key={index}
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onFocus={(e) => e.target.select()}
            />
          );
        })}
      </div>
      {isMobile && (
        <button
          className="border-btn mb-3 mt-3 p-2 text-center"
          onClick={closeOTPScreen}
        >
          Cancel
        </button>
      )}
      <button
        className="login-btn mb-3 mt-3 p-2 text-center w-75"
        onClick={validateOTP}
      >
        Validate
      </button>
      <p className={`${isMobile ? "text-center" : ""} text--medium`}>
        Didn't receive OTP?{" "}
        {countdown !== 0 ? (
          `Resend in ${countdown}s`
        ) : (
          <span
            onClick={resetOtpCountdown}
            className="blue--text text-decoration-underline"
          >
            Resend
          </span>
        )}
      </p>
    </div>
  );
}
